export const toTimestamp = (date: Date) => {
  return Math.floor(date.getTime() / 1000);
};
